import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	metamenu: {
		display: "flex",
		flexDirection: "column",
		"& ul": {
			display: "flex",
			flex: 1,
			flexWrap: "wrap",
			justifyContent: "flex-start",
			listStyle: "none",
			margin: theme?.spacing(0, -1)
		},
		[theme.breakpoints.up("lg")]: {
			justifyContent: "flex-end",
			flexDirection: "row"
		}
	},
	copyrights: {
		color: "#B2B2B2",
		display: "block",
		margin: theme.spacing(0.5, 0, 0.5, 0),
		...theme?.customTypography?.footer?.metamenu,
		[theme.breakpoints.up("lg")]: {
			margin: theme.spacing(0.5, 2, 0.5, 0)
		}
	}
}));

export default styles;
